import { ActiveSessionAlert } from '@/components/home/ActiveSessionAlert';
import type { SessionOut } from '@/api/charging';

/** Banner de sessão ativa flutuando sobre o mapa — composto dentro do
 * overlay de topo da Home (junto com "Ver lista"), independente do estado
 * da sheet (peek/expandida): a sessão ativa nunca fica escondida atrás da
 * estação selecionada. Sem posicionamento próprio — quem posiciona é o
 * container flex do overlay em `Home.tsx`. */
export function ActiveBannerFloat({ session }: { session: SessionOut }) {
  return (
    <div className="pointer-events-auto">
      <ActiveSessionAlert session={session} />
    </div>
  );
}
